<template>
  <div class="container_Sidebar">
    <div class="menu_Sidebar">
      <div class="menuTop_Sidebar" v-if="loggedUser">
        <div class="menuTopHome_Sidebar">
          <div class="routerLink_Sidebar">
            <p-icon icon="IconProsegur" :size="32" color="#FFFFFF" />
          </div>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="$ability.can('read', 'SaldosPage')"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.saldos')"
        >
          <router-link
            :to="{ name: 'todos' }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('saldos')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconBalance" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="isBCR"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.saldosBCR')"
        >
          <router-link
            :to="{ name: 'todosBCR' }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('saldosBCR')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconBCR" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="$ability.can('read', 'DocumentacionPage')"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.documentos')"
        >
          <router-link
            :to="{ name: 'documentacion' }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('documentacion')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconDocument" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="$ability.can('read', 'AdministracionPage')"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.administracion')"
        >
          <router-link
            :to="{ name: 'administracion', params: { option: 'usuarios' } }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('administracion')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconAdministration" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="$ability.can('read', 'TransferenciasPage')"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.transferencias')"
        >
          <router-link
            :to="{ name: 'transferencias', params: { option: 'propias' } }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('transferencias')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconTransfers" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="$ability.can('read', 'VideosPage')"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.videos')"
        >
          <router-link
            :to="{ name: 'videos' }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('videos')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconVideos" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
        <div
          :class="['menuTopItem_Sidebar']"
          v-if="$ability.can('read', 'ReportesPage')"
          v-b-tooltip.bottom.noninteractive="tooltipOptions"
          :title="$t('sidebar.reportes')"
        >
          <router-link
            :to="{ name: 'reportes' }"
            custom
            v-slot="{ navigate }"
            :class="classMenuActive('reportes')"
          >
            <div @click="navigate" class="routerLink_Sidebar">
              <p-icon icon="IconReport" :size="24" color="#FFFFFF" />
            </div>
          </router-link>
        </div>
      </div>
      <div class="menuBotton_Sidebar" v-if="loggedUser">
        <div class="user_Sidebar">
          <p-drop-down-container>
            <template #content>
              <div class="contentClickUser_Sidebar">
                <p-icon icon="IconLetter" :size="36" color="#ffd102">{{ letterUser }}</p-icon>
              </div>
            </template>
            <div class="containerMenuUser_Sidebar">
              <div class="nombreUserEmail_Sidebar">
                <div class="nombreUser_Sidebar">
                  {{ fullName }}
                </div>
                <div class="emailUser_Sidebar">{{ loggedUser.codEmail }}</div>
              </div>
              <div>
                <div class="container-item" @click="openDisclaimerModal()">
                  <b-icon class="icon-item" icon="key" aria-hidden="true"></b-icon>
                  <div class="text-item">{{ $t("Terminos y Condiciones") }}</div>
                </div>
              </div>
              <div>
                <div class="signout_Sidebar" @click="logout()">
                  <b-icon icon="power" aria-hidden="true"></b-icon>
                  <div class="actionExitText_Sidebar">{{ $t("action.exit") }}</div>
                </div>
              </div>
            </div>
          </p-drop-down-container>
        </div>
      </div>
    </div>
    <div class="subMenu_Sidebar" v-show="showSubMenu && false">
      <div class="subMenuHiden_Sidebar" @click="showSubMenu = false">
        <p-icon icon="IconChevronLeft" :size="24" color="#4c4c4c"></p-icon>
      </div>
      <div class="subMenuTitle_Sidebar">{{ titleSubMenu }}</div>
      <div class="subMenuItems_Sidebar">
        <div
          :class="['subMenuItem_Sidebar', classSubMenuActive(subMenu.name)]"
          v-for="(subMenu, index) in subMenuComp"
          :key="index + 'subMenu'"
        >
          <router-link :to="{ name: subMenu.name }" custom v-slot="{ navigate }">
            <div @click="navigate" class="routerLink_Sidebar">
              <div class="textMenu_Sidebar">{{ $t("sidebar.dashboard") }}</div>
              {{ $t("menu." + subMenu.name) }}
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <div>
      <div class="subMenu2_Sidebar" v-show="!showSubMenu && false">
        <div class="subMenuShow_Sidebar" @click="showSubMenu = true">
          <p-icon icon="IconChevronRight" :size="24" color="#4c4c4c"></p-icon>
        </div>
      </div>
    </div>
    <DisclaimerModal v-if="loggedUser"> </DisclaimerModal>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { mapGetters } from "vuex";
import { IPermiso, IUsuario } from "@/entities";
import DisclaimerModal from "@/components/common/widgets/DisclaimerModal.vue";

@Component({
  name: "sidebar",
  components: { DisclaimerModal },
  computed: {
    ...mapGetters(["getIsSignedIn"]),
  },
})
export default class Sidebar extends Vue {
  @Getter("getLoggedUser") loggedUser: IUsuario | undefined;
  @Action("logout") logout!: () => Promise<void>;
  @Getter("getUrl") getUrl!: string;

  showSubMenu = true;
  titleSubMenu = "";
  menu = [
    { name: "dashboard", parent: "dashboard" },
    { name: "todos", parent: "saldos" },
    { name: "entradas", parent: "saldos" },
    { name: "salidas", parent: "saldos" },
    { name: "todosBCR", parent: "saldosBCR" },
    { name: "entradasBCR", parent: "saldosBCR" },
    { name: "salidasBCR", parent: "saldosBCR" },
    { name: "historico", parent: "documentacion" },
    { name: "delegacion", parent: "documentacion" },
    { name: "importacion", parent: "documentacion" },
    { name: "documentos", parent: "documentacion" },
    { name: "administracion", parent: "administracion" },
    { name: "clientes", parent: "administracion" },
    { name: "usuarios", parent: "administracion" },
    { name: "columnas", parent: "administracion" },
    { name: "cargas", parent: "administracion" },
    { name: "transferencias", parent: "transferencias" },
    { name: "propias", parent: "transferencias" },
    { name: "publicas", parent: "transferencias" },
    { name: "videos", parent: "videos" },
    { name: "reportes", parent: "reportes" },
    { name: "notificaciones", parent: "notificaciones" },
    { name: "recientes", parent: "notificaciones" },
    { name: "historicos", parent: "notificaciones" },
  ];

  public tooltipOptions = {
    customClass: "tooltip-dark",
    delay: { show: 1000, hide: 0 },
  };

  get fullName(): string {
    return `${this.loggedUser?.desNombre} ${this.loggedUser?.desApellidos}`;
  }
  get letterUser(): string {
    return this.loggedUser!.desNombre[0].toUpperCase();
  }

  get subMenuComp(): { name: string; parent: string }[] {
    const subMenu = this.menu.find((me) => me.name === this.$route.name);
    if (subMenu) {
      this.titleSubMenu = this.$t("menu." + subMenu.parent) + "";
      return this.menu.filter((me) => me.parent === subMenu.parent);
    } else {
      return [];
    }
  }

  classMenuActive(nameRouter: string): string {
    const subMenu = this.menu.find((me) => me.name === this.$route.name);
    if (subMenu && subMenu.parent === nameRouter) {
      return "menuTopItemActive_Sidebar";
    } else {
      return "";
    }
  }

  classSubMenuActive(nameRouter: string): string {
    if (this.$route.name === nameRouter) {
      return "subMenuItemActive_Sidebar";
    } else {
      return "";
    }
  }

  openDisclaimerModal(): void {
    return this.$bvModal.show("disclaimer-modal");
  }

  get isBCR(): boolean {
    const permiso = this.loggedUser?.permisos.find((permiso: IPermiso) => permiso.pais.bcr);
    return this.$ability.can("read", "SaldosPage") && !!permiso;
  }
}
</script>

<style lang="scss" scoped>
.active {
  border-right: 3px solid var(--amarillo-prosegur);
}
.pointer {
  cursor: pointer;
}
.menu_Sidebar {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  justify-content: space-between;
  align-items: center;
}
.menuTop_Sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.menuTopHome_Sidebar {
  padding: 15px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #fff;
}

.menuTopItem_Sidebar {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 0.5em 0;

  .routerLink_Sidebar {
    padding: 0.5em 0;

    @media (max-height: 767px) {
      padding: 0.2em 0;
    }
  }
}
.routerLink_Sidebar {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #fff;
  cursor: pointer;
  width: 100%;

  &:hover {
    background-color: rgba(255, 255, 255, 0.15);
  }
}
.menuTopItemActive_Sidebar {
  border-right: 3px solid #ffd102;
}

.menuBotton_Sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.subMenu_Sidebar {
  position: relative;
  min-width: 200px;
  background-color: #323232;

  height: 100vh;
}
.subMenu2_Sidebar {
  position: relative;
}
.subMenuHiden_Sidebar {
  position: absolute;
  top: 10px;
  right: -10px;
  width: 32px;
  height: 24px;
  align-items: center;
  text-align: center;
  border-radius: 12px;
  background-color: #ffd102;
  cursor: pointer;
}

.subMenuShow_Sidebar {
  position: absolute;
  top: 2px;
  right: -10px;
  border-radius: 2px 12px 12px 2px;
  background-color: #ffd102;
  cursor: pointer;
}
.subMenuTitle_Sidebar {
  background-color: rgba(173, 173, 173, 0.1);
  height: 46px;
  color: #ffffff;
  text-transform: uppercase;
  font-weight: bold;
  padding: 15px 15px;
  line-height: 1.33;
}
.subMenuItems_Sidebar {
  display: flex;
  flex-direction: column;
}
.subMenuItem_Sidebar {
  padding: 15px;
  color: #b7b7b7;
  cursor: pointer;
}
.subMenuItemActive_Sidebar {
  color: #ffffff;
  border-left: 2px solid #ffd102;
}
.textMenu_Sidebar {
  padding: 0.2rem;
  text-transform: uppercase;
  font-size: 0.6rem;
  text-align: center;
}
.user_Sidebar {
  padding: 1rem 0;
}
.contentClickUser_Sidebar {
  cursor: pointer;
}

.containerMenuUser_Sidebar {
  padding: 0 0.5rem;
}
.nombreUserEmail_Sidebar {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem 0 1.5rem 0;
}
.nombreUser_Sidebar {
  white-space: nowrap;
  font-weight: bold;
  color: #4c4c4c;
}
.emailUser_Sidebar {
  font-size: 0.7rem;
  color: #6f6f6f;
  white-space: nowrap;
}
.signout_Sidebar {
  border-top: solid 0.5px #d5d5d5;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.actionExitText_Sidebar {
  margin-left: 0.3rem;
  font-size: 0.8rem;
}
.container-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.icon-item {
  margin: 0.25rem !important;
}
.text-item {
  margin: 0.25rem !important;
  font-size: 0.7rem;
}
.tooltip-dark::v-deep .tooltip-inner {
  background-color: #6c757d;
  color: var(--blanco-prosegur);
}
</style>
